import request from '@/utils/request'

export function fetchList(query) {
  return request({
    url: '/menu/list',
    method: 'get',
    params: query
  })
}
